import { Callout } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { type Column } from '../../template';

export const UsedDeletedCustomFieldsCallout = ({
  deletedCustomFields,
}: {
  deletedCustomFields: Column[];
}) => {
  const { t } = useTranslation('global');

  if (deletedCustomFields.length === 1) {
    return (
      <Callout
        variant="warning"
        className="my-8"
        title={t('exports.errors.deletedCustomField.single', {
          name: deletedCustomFields[0].name,
        })}
      />
    );
  }

  return (
    <Callout
      variant="warning"
      className="my-8"
      title={t('exports.errors.deletedCustomField.multiple')}
    >
      <ul className="list-disc">
        {deletedCustomFields.map((field) => (
          <li key={field.name}>{field.name}</li>
        ))}
      </ul>
    </Callout>
  );
};
